<template>
    <section class="section section--products">
        <Heading text="Naše produkty" />
        <ul class="section__products">
            <li class="section__products__product" v-for="product in products" v-bind:key="product.name">
                <Product :image="product.image" :name="product.name" :link="product.link" />
            </li>
        </ul>
    </section>
</template>

<script>
    import Heading from './includes/Heading.vue';
    import Product from './includes/Product.vue';

    export default {
        name: 'Products',
        components: {
            Heading,
            Product
        },
        data() {
            return {
                products: [
                    {
                        image: 'product-1',
                        name: 'Firemní rozvoj na míru',
                        link: '#testimonials'
                    },
                    {
                        image: 'product-2',
                        name: 'Karetní hra Get2KnowMe®',
                        link: 'https://get2knowme.cz'
                    },
                    {
                        image: 'product-3',
                        name: 'Seberozvojové publikace',
                        link: 'https://get2knowme.cz/shop'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {

        &__products {
            display: flex;
            justify-content: space-between;
            max-width: 120rem;
            padding-left: 0;
            margin: 6rem auto 0 auto;
            list-style-type: none;

            &__product {
                width: 29%;
                cursor: pointer;
            }
        }

        &--products {
            background-color: #f3f5f8;
        }
    }

    @media (max-width: 767px) {

        .section {

            &__products {
                flex-wrap: wrap;
                margin-top: 0;

                &__product {
                    width: 100%;

                    &:not(:last-of-type) {
                        margin-bottom: 4rem;
                    }
                }
            }
        }
    }

</style>
